import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Row, Table, message } from 'antd';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { FormInstance } from 'rc-field-form';
import { updateAdditionalInfo } from '@app/api/import.api';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { EditOutlined } from '@ant-design/icons';

interface AdditionalInfoProps {
  form: FormInstance;
  importStatus: string | null;
  importData: any;
  serviceCharges: any[];
  import_id: string;
  department: any;
  editInfo: any;
}

const AdditionalInfo: React.FC<AdditionalInfoProps> = ({
  form,
  importData,
  serviceCharges,
  import_id,
  department,
  editInfo,
}) => {
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});
  const [isEditing, setIsEditing] = useState(false);
  const canEdit = isEditing;

  useEffect(() => {
    console.log('passed serviceCharges:', serviceCharges);
    if (importData) {
      console.log(canEdit);
      form.setFieldsValue({
        custom_deck_no: importData?.custom_deck_no || '',
        site_visit: importData?.site_visit || '',
        container_type: importData?.container_type || '',
        sample_count: importData?.sample_count || '',
      });
    }
  }, [form, importData, serviceCharges]);

  useEffect(() => {
    if (importData?.import_service_charges) {
      const initialQuantities: { [key: number]: number } = {};
      importData.import_service_charges.forEach((sc: any) => {
        initialQuantities[sc.service_charge_id] = Number(sc.qty);
      });
      setQuantities(initialQuantities);
    }
  }, [importData]);

  // const departmentCharges =
  //   serviceCharges?.filter((charge) => String(charge.department_id) === String(department?.id)) || [];

  const departmentCharges = serviceCharges || [];

  const handleSave = async () => {
    const values = form.getFieldsValue();

    const import_service_charges = Object.entries(quantities)
      .filter(([_, qty]) => qty > 0)
      .map(([service_charge_id, qty]) => ({
        import_id: Number(import_id), // include import_id to match composite primary key
        service_charge_id: Number(service_charge_id),
        qty,
      }));

    const payload = {
      ...values,
      import_service_charges,
    };

    console.log('Payload sent to backend:', payload);

    try {
      await updateAdditionalInfo(Number(import_id), payload);
      message.success('Additional Info saved successfully.');
      setIsEditing(false);
    } catch (error) {
      console.error('Save failed:', error);
      message.error('Failed to save additional info.');
    }
  };

  const fields = [
    {
      name: 'custom_deck_no',
      label: 'Cust Desk No',
      component: canEdit ? (
        <Input
          value={form.getFieldValue('custom_deck_no')}
          onChange={(e) => form.setFieldsValue({ custom_deck_no: e.target.value })}
          placeholder="Enter Cust Desk No"
        />
      ) : (
        <BaseInput readOnly value={form.getFieldValue('custom_deck_no')} />
      ),
    },
    {
      name: 'site_visit',
      label: 'Site Visit',
      component: canEdit ? (
        <BaseSelect
          placeholder="Select Site Visit Status"
          options={[
            { value: 'PENDING', label: 'PENDING' },
            { value: 'COMPLETED', label: 'COMPLETED' },
            { value: 'SKIPPED', label: 'SKIPPED' },
          ]}
          onChange={(value) => form.setFieldsValue({ site_visit: value })}
        />
      ) : (
        <BaseInput readOnly value={form.getFieldValue('site_visit')} />
      ),
    },
    {
      name: 'container_type',
      label: 'Container Type',
      component: canEdit ? (
        <BaseSelect
          placeholder="Select Container Type"
          options={[
            { value: 'FULL', label: 'FULL' },
            { value: 'PARTIL', label: 'PARTIL' },
            { value: 'MIX', label: 'MIX' },
          ]}
          onChange={(value) => form.setFieldsValue({ container_type: value })}
        />
      ) : (
        <BaseInput readOnly value={form.getFieldValue('container_type')} />
      ),
    },
    {
      name: 'sample_count',
      label: 'Sample Count',
      component: canEdit ? (
        <Input
          type="number"
          step="0.01"
          value={form.getFieldValue('sample_count')}
          onChange={(e) =>
            form.setFieldsValue({
              sample_count: parseFloat(e.target.value) || 0,
            })
          }
          placeholder="Enter Sample Count"
        />
      ) : (
        <BaseInput readOnly value={form.getFieldValue('sample_count')} />
      ),
    },
  ];
  const importServiceChargeRows =
    importData?.import_service_charges?.map((isc: any, index: number) => {
      const unitPrice = isc.service_charge
        ? parseFloat(serviceCharges.find((sc) => sc.value === isc.service_charge_id)?.unit_price ?? '0')
        : 0;
      const quantity = parseFloat(isc.qty);
      return {
        key: index,
        name: isc.service_charge ? `${isc.service_charge.code} - ${isc.service_charge.name}` : 'Unknown',
        quantity,
        unitPrice,
        totalPrice: unitPrice * quantity,
      };
    }) || [];

  const columns = [
    {
      title: 'Service Charge',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    // {
    //   title: 'Unit Price',
    //   dataIndex: 'unitPrice',
    //   key: 'unitPrice',
    //   render: (value: number) => value.toFixed(2),
    // },
    // {
    //   title: 'Total Price',
    //   dataIndex: 'totalPrice',
    //   key: 'totalPrice',
    //   render: (value: number) => value.toFixed(2),
    // },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        {editInfo && !isEditing && (
          <BaseCol span={24} style={{ textAlign: 'right' }}>
            <BaseButton type="primary" size="small" onClick={() => setIsEditing(true)} icon={<EditOutlined />}>
              Update Additional Info
            </BaseButton>
          </BaseCol>
        )}
        <br />

        {fields.map((field) => (
          <BaseCol xs={24} md={12} key={String(field.name)}>
            <Form.Item label={field.label} name={field.name}>
              {field.component}
            </Form.Item>
          </BaseCol>
        ))}

        {/* SERVICE CHARGES */}
        {/* {departmentCharges?.length > 0 && ( */}
        <>
          <Col span={24}>
            <h3 style={{ marginTop: 16 }}>Service Charges</h3>
          </Col>
          {departmentCharges.map((charge) => (
            <React.Fragment key={charge.value}>
              {' '}
              {/* charge.id → charge.value */}
              <BaseCol xs={24} md={12}>
                <Form.Item label="Service Charge">
                  <BaseInput readOnly value={charge.label} /> {/* charge.name → charge.label */}
                </Form.Item>
              </BaseCol>
              <BaseCol xs={24} md={12}>
                <Form.Item label="Quantity">
                  {canEdit && editInfo ? (
                    <Input
                      type="number"
                      min={0}
                      value={quantities[charge.value] || 0}
                      onChange={(e) =>
                        setQuantities((prev) => ({
                          ...prev,
                          [charge.value]: parseInt(e.target.value) || 0,
                        }))
                      }
                    />
                  ) : (
                    <BaseInput readOnly value={quantities[charge.value] || 0} />
                  )}
                </Form.Item>
              </BaseCol>
            </React.Fragment>
          ))}
        </>
        {/* )} */}

        {canEdit && editInfo && (
          <BaseCol span={24} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <BaseButton size="middle" onClick={() => setIsEditing(false)}>
              Cancel
            </BaseButton>
            <BaseButton type="primary" size="middle" onClick={handleSave}>
              Save
            </BaseButton>
          </BaseCol>
        )}
      </Row>
      {importServiceChargeRows.length > 0 && (
        <>
          <h3>Added Service Charges</h3>
          <Table dataSource={importServiceChargeRows} columns={columns} pagination={false} bordered size="small" />
        </>
      )}
    </>
  );
};

export default AdditionalInfo;
